import { Badge, Flex, Spacer } from '@jisr-hr/design-system'

type optionTypes = { label: string; value: string | number; testId: string }

type MultiBadgesCheckListProps = {
  labelKey: string
  options: Array<optionTypes>
  selected: Array<string | number>
  valueKey: string
  onChange: (value: string | number) => void
}

const MultiBadgesCheckList = (props: MultiBadgesCheckListProps): JSX.Element => {
  const { selected, options, onChange, valueKey = 'value', labelKey = 'label' } = props

  const optType = {
    true: 'primary',
    false: 'gray',
  }

  return (
    <Flex
      flexWrap
      style={{ gap: 2 }}
    >
      {options.map((data: optionTypes, ind: number) => {
        return (
          <Flex key={ind}>
            <Badge
              label={data?.[labelKey]}
              type={optType[`${Boolean(selected?.includes(data?.[valueKey]))}`]}
              onClick={(): void => onChange(data?.[valueKey])}
              bordered
              variant="stroke"
              style={{ cursor: 'pointer', userSelect: 'none' }}
              data-testid={data.testId}
            />
            <Spacer width={8} />
          </Flex>
        )
      })}
    </Flex>
  )
}

export default MultiBadgesCheckList
